export enum SNACKBAR_ALERT_TYPES {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
}
